export default "__VITE_ASSET__CsPiP93$__"